import * as React from "react";
import { createContext, useContext } from "react";
import useInputMetrics from "hooks/useInputMetrics";
const EMPTY_CONTEXT = {
  metricsByInputId: {},
  isInitialLoading: false,
  isError: false,
  isFieldRequested: () => false
};
const InputMetricsContext = createContext(EMPTY_CONTEXT);
export const InputMetricsProvider = ({ inputIds, fields, children = void 0 }) => {
  const { metricsByInputId, isInitialLoading, isError } = useInputMetrics(inputIds, fields);
  const requestedFields = new Set(fields);
  const value = {
    metricsByInputId,
    isInitialLoading,
    isError,
    isFieldRequested: (field) => requestedFields.has(field)
  };
  return /* @__PURE__ */ React.createElement(InputMetricsContext.Provider, { value }, children);
};
export const useInputMetricsContext = () => useContext(InputMetricsContext);
export const useInputMetricsFor = (inputId) => {
  const { metricsByInputId, isInitialLoading, isError } = useContext(InputMetricsContext);
  return {
    metrics: metricsByInputId[inputId],
    isInitialLoading,
    isError
  };
};
export default InputMetricsContext;
